import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M13 8H4M13 16H4" vectorEffect="non-scaling-stroke" />
		<Path d="M20.1241 17.5H18.1241C18.1241 15.4333 20.1241 15.95 20.1241 14.4C20.1241 13.625 19.1241 12.975 18.1241 13.75" strokeLinecap="square" vectorEffect="non-scaling-stroke" />
		<Path d="M19 10V5.5L17.5 6" vectorEffect="non-scaling-stroke" />
	</SVG>
);
